import * as React from "react";
import axios from "axios";
import { Form, Button, Icon } from "antd";
import { ImageFile } from "react-dropzone";
import { FormikProps, Field, withFormik, Form as FForm } from "formik";
// import { Image } from "cloudinary-react";
import AvatarEditor from "react-avatar-editor";

// import { userValidationSchema } from '@bakbak/common';
import {
  UpdateProfileMutationVariables,
  UpdateProfileMutation_updateProfile,
  UpdateProfileMutation_updateProfile_profile,
  S3SignMutationVariables,
  S3SignMutation_signS3
} from "@bakbak/controller";

import { InputField } from "../../../util/InputField";
import { DropzoneField } from "../../../util/DropzoneField";
import {
  THEME_COLOR,
  DUMMY_PROFILE_PIC_URI
  // CLOUDINARY_URL
} from "../../../constants";
import { base64StringtoFile } from "../../../util/ImageCrop";
// import { DropzoneClass } from "../../../util/DropZoneClass";

const FormItem = Form.Item;

interface FormValues {
  email: string;
  userName: string;
  password: string;
  picture: ImageFile | null;
}
interface Props {
  loggedUser: UpdateProfileMutation_updateProfile_profile;
  submit: (
    values: UpdateProfileMutationVariables
  ) => Promise<UpdateProfileMutation_updateProfile | null>;
  onComplete: (
    user: UpdateProfileMutation_updateProfile_profile | null
  ) => void;
  onCancel: () => void;
  signS3Mutate: (
    variables: S3SignMutationVariables
  ) => Promise<S3SignMutation_signS3 | null>;
}
interface State {
  secureText: boolean;
}

let avatarEditorRef: any;
export class UpdateProfileForm extends React.PureComponent<
  FormikProps<FormValues> & Props,
  State
> {
  state = {
    secureText: true
  };
  constructor(props: any) {
    super(props);
    avatarEditorRef = React.createRef();
  }
  toggleSecureText = () => {
    this.setState(state => ({ secureText: !state.secureText }));
  };

  renderImage = () => {
    const { loggedUser, values } = this.props;
    if (values.picture && values.picture.preview) {
      return (
        <AvatarEditor
          ref={ref => (avatarEditorRef = ref)}
          image={values.picture}
          width={80}
          height={80}
          color={[255, 255, 255, 0.6]} // RGBA
          rotate={0}
        />
      );
    } else if (loggedUser.pictureUrl) {
      return <img src={loggedUser.pictureUrl} style={styles.imageStyle} />;
    } else {
      return (
        <img
          src={`${DUMMY_PROFILE_PIC_URI}${loggedUser.userName}.png`}
          style={styles.imageStyle}
        />
      );
    }
  };

  render() {
    const { loggedUser } = this.props;
    return (
      <FForm style={{ display: "flex", marginTop: 20 }}>
        <div style={{ width: 400, margin: "auto" }}>
          <div
            style={{
              fontSize: 32,
              fontWeight: 600,
              marginBottom: 20,
              color: THEME_COLOR
            }}
          >
            Update your details
          </div>
          <Field
            name="email"
            label="Email"
            prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
            placeholder="email"
            component={InputField}
            value={loggedUser.email}
          />
          <Field
            name="userName"
            label="User name"
            prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
            placeholder="userName"
            component={InputField}
            value={loggedUser.userName}
          />
          <Field
            name="password"
            label={
              <span>
                New Password
                <span style={{ marginLeft: 10, fontSize: 10, color: "grey" }}>
                  (*For security reasons we are not showing your old password)
                </span>
              </span>
            }
            prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
            placeholder="********"
            type="password"
            component={InputField}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: 30,
              justifyContent: "space-between"
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between"
              }}
            >
              <div>Change photo:</div>
              {this.renderImage()}
            </div>
            <Field name="picture" component={DropzoneField} />
          </div>

          <FormItem>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
              }}
            >
              <Button htmlType="submit" style={styles.submitButtonStyle}>
                Update Profile
              </Button>
              <Button
                onClick={this.props.onCancel}
                style={styles.cancelButtonStyle}
              >
                Cancel
              </Button>
            </div>
          </FormItem>
        </div>
      </FForm>
    );
  }
}

export const UpdateProfileView = withFormik<Props, FormValues>({
  validate: (values, props) => {
    const errors: any = {};
    const { loggedUser } = props;
    if (
      values.email === loggedUser.email &&
      values.userName === loggedUser.userName &&
      values.picture === loggedUser.pictureUrl &&
      values.password === ""
    ) {
      errors.password = "You did not make any changes";
    }
    return errors;
  },
  mapPropsToValues: () => ({
    email: "",
    userName: "",
    password: "",
    picture: null
  }),
  handleSubmit: async (values, { props, setErrors, resetForm }) => {
    const formInput = { ...values, userId: props.loggedUser.id };

    let responseImage;
    let picture;
    // console.log(values.picture);
    if (values.picture) {
      if (avatarEditorRef) {
        const canvasScaled = avatarEditorRef.getImageScaledToCanvas();
        const dataURL = canvasScaled.toDataURL();
        const file = base64StringtoFile(
          dataURL,
          values.userName + values.picture.name
        );

        const formData = new FormData();
        formData.append("file", file);
        formData.append("upload_preset", "default-preset");
        responseImage = await axios.post(
          `https://api.cloudinary.com/v1_1/bakbak24/image/upload`,
          formData
        );
        picture = responseImage.data.secure_url;
      }
    }
    const response = await props.submit({
      ...formInput,
      picture
    });
    if (response && response.errors) {
      setErrors(response.errors as any);
    } else if (response) {
      resetForm();
      props.onComplete(response.profile);
    }
  }
})(UpdateProfileForm);

const styles = {
  submitButtonStyle: {
    width: "45%",
    backgroundColor: THEME_COLOR,
    color: "white",
    borderColor: THEME_COLOR
  },
  cancelButtonStyle: {
    width: "45%",
    backgroundColor: "Grey",
    color: "white",
    borderColor: "grey"
  },
  imageStyle: {
    borderRadius: 10,
    width: 80,
    height: 80,
    imageOrientation: "from-image"
  }
};



// WEBPACK FOOTER //
// ./src/modules/profile/update/UpdateProfileView.tsx